// extracted by mini-css-extract-plugin
module.exports = {"container":"PortfolioCrazy_container__spMO5"};